<template>
  <!-- header (Zain style) -->
        <header class="zain-header">
            <div class="container">
                <div class="zain-header__content">
                    <!-- Right side: Logo -->
                    <div class="zain-header__logo">
                        <router-link to="/" class="logo-link">
                            <span class="logo-text">السكري</span>
                        </router-link>
                    </div>

                    <!-- Navigation Links -->
                    <nav class="zain-header__nav">
                        <router-link to="/" class="nav-link">
                            <svg class="nav-icon" viewBox="0 0 20 20">
                                <path fill="currentColor" d="M18.121,9.88l-7.832-7.836c-0.155-0.158-0.428-0.155-0.584,0L1.842,9.913c-0.262,0.263-0.073,0.705,0.292,0.705h2.069v7.042c0,0.227,0.187,0.414,0.414,0.414h3.725c0.228,0,0.414-0.188,0.414-0.414v-3.313h2.483v3.313c0,0.227,0.187,0.414,0.413,0.414h3.726c0.229,0,0.414-0.188,0.414-0.414v-7.042h2.068h0.004C18.331,10.617,18.389,10.146,18.121,9.88 M14.963,17.245h-2.896v-3.313c0-0.229-0.186-0.415-0.414-0.415H8.342c-0.228,0-0.414,0.187-0.414,0.415v3.313H5.032v-6.628h9.931V17.245z M3.133,9.79l6.864-6.868l6.867,6.868H3.133z"/>
                            </svg>
                            الرئيسية
                        </router-link>

                        <!-- Categories Dropdown -->
                        <div class="nav-dropdown">
                            <button type="button" class="nav-link" @click="toggleDropdown">
                                <svg class="nav-icon" viewBox="0 0 20 20">
                                    <path fill="currentColor" d="M7.228,11.464H1.996c-0.723,0-1.308,0.587-1.308,1.309v5.232c0,0.722,0.585,1.308,1.308,1.308h5.232c0.723,0,1.308-0.586,1.308-1.308v-5.232C8.536,12.051,7.95,11.464,7.228,11.464z M7.228,17.351c0,0.361-0.293,0.654-0.654,0.654H2.649c-0.361,0-0.654-0.293-0.654-0.654v-3.924c0-0.361,0.292-0.654,0.654-0.654h3.924c0.361,0,0.654,0.293,0.654,0.654V17.351z M17.692,11.464H12.46c-0.723,0-1.308,0.587-1.308,1.309v5.232c0,0.722,0.585,1.308,1.308,1.308h5.232c0.722,0,1.308-0.586,1.308-1.308v-5.232C19,12.051,18.414,11.464,17.692,11.464z M17.692,17.351c0,0.361-0.293,0.654-0.654,0.654h-3.924c-0.361,0-0.654-0.293-0.654-0.654v-3.924c0-0.361,0.293-0.654,0.654-0.654h3.924c0.361,0,0.654,0.293,0.654,0.654V17.351z M7.228,1H1.996C1.273,1,0.688,1.585,0.688,2.308V7.54c0,0.723,0.585,1.308,1.308,1.308h5.232c0.723,0,1.308-0.585,1.308-1.308V2.308C8.536,1.585,7.95,1,7.228,1z M7.228,6.886c0,0.361-0.293,0.654-0.654,0.654H2.649c-0.361,0-0.654-0.292-0.654-0.654V2.962c0-0.361,0.292-0.654,0.654-0.654h3.924c0.361,0,0.654,0.292,0.654,0.654V6.886z M17.692,1H12.46c-0.723,0-1.308,0.585-1.308,1.308V7.54c0,0.723,0.585,1.308,1.308,1.308h5.232C18.414,8.848,19,8.263,19,7.54V2.308C19,1.585,18.414,1,17.692,1z M17.692,6.886c0,0.361-0.293,0.654-0.654,0.654h-3.924c-0.361,0-0.654-0.292-0.654-0.654V2.962c0-0.361,0.293-0.654,0.654-0.654h3.924c0.361,0,0.654,0.292,0.654,0.654V6.886z"/>
                                </svg>
                                الفـــئــات
                                <svg class="dropdown-arrow" viewBox="0 0 20 20" :class="{ 'rotated': isDropdownOpen }">
                                    <path fill="currentColor" d="M5 7l5 5 5-5z"/>
                                </svg>
                            </button>
                            <ul class="categories-dropdown" v-show="isDropdownOpen">
                                <li v-for="category in categoris" :key="category.id">
                                    <router-link :to="{ name: 'Categorys', params: { catid: category.id }}" @click="closeDropdown">
                                        {{ category.name_ar }}
                                    </router-link>
                                </li>
                            </ul>
                        </div>
                    </nav>

                    <!-- Center: Search bar -->
                    <div class="zain-header__search">
                        <form class="search-form" @submit.prevent="SearchData()">
                            <input
                                class="search-input"
                                v-model="search"
                                type="text"
                                placeholder="ابحث عن المحتوى...">
                        </form>
                    </div>

                    <!-- Left side: Zain logo + Buttons -->
                    <div class="zain-header__actions">
                        <!-- Auth buttons -->
                        <div class="auth-buttons">
                            <template v-if="showHeader">
                                <router-link to="/Unsubscribes" class="btn-login">
                                    الخروج
                                    <svg class="btn-icon" viewBox="0 0 20 20">
                                        <path d="M10,0.891c-5.031,0-9.109,4.079-9.109,9.109c0,5.031,4.079,9.109,9.109,9.109c5.031,0,9.109-4.078,9.109-9.109C19.109,4.969,15.031,0.891,10,0.891z M10,18.317c-4.593,0-8.317-3.725-8.317-8.317c0-4.593,3.724-8.317,8.317-8.317c4.593,0,8.317,3.724,8.317,8.317C18.317,14.593,14.593,18.317,10,18.317z"/>
                                    </svg>
                                </router-link>
                                <span class="user-msisdn">{{ $cookie.getCookie("msisdn") }}</span>
                            </template>
                            <template v-else>
                                <router-link to="/Login" class="btn-login">
                                    الدخول
                                    <svg class="btn-icon" viewBox="0 0 20 20">
                                        <path d="M0,0v20h20V0H0z M18.5,18.5h-17v-17h17V18.5z M7.5,14.5l1.4,1.4l5.6-5.6l-5.6-5.6L7.5,6.1l4.1,4.1L7.5,14.5z"/>
                                    </svg>
                                </router-link>
                                <router-link to="/Subscribes" class="btn-subscribe">
                                    <svg class="btn-icon" viewBox="0 0 20 20">
                                        <path d="M12.443,9.672c0.203-0.496,0.329-1.052,0.329-1.652c0-1.969-1.241-3.565-2.772-3.565S7.228,6.051,7.228,8.02c0,0.599,0.126,1.156,0.33,1.652c-1.379,0.555-2.31,1.553-2.31,2.704c0,1.75,2.128,3.169,4.753,3.169c2.624,0,4.753-1.419,4.753-3.169C14.753,11.225,13.821,10.227,12.443,9.672z"/>
                                    </svg>
                                    الاشتراك
                                </router-link>
                            </template>
                        </div>

                        <!-- Zain Logo -->
                        <router-link to="/" class="zain-logo">
                            <img src="../../assets/image/zain_gray.png" alt="Zain">
                        </router-link>
                    </div>

                    <!-- Mobile menu button -->
                    <button class="mobile-menu-btn" type="button" @click="toggleMobileMenu" :class="{ 'active': isMobileMenuOpen }">
                        <span></span>
                        <span></span>
                        <span></span>
                    </button>
                </div>

                <!-- Mobile Menu Overlay -->
                <div class="mobile-menu-overlay" v-show="isMobileMenuOpen" @click="closeMobileMenu"></div>

                <!-- Mobile Menu -->
                <nav class="mobile-menu" :class="{ 'open': isMobileMenuOpen }">
                    <div class="mobile-menu__header">
                        <span class="mobile-menu__title">القائمة</span>
                        <button class="mobile-menu__close" @click="closeMobileMenu">
                            <svg viewBox="0 0 24 24" width="24" height="24">
                                <path fill="currentColor" d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
                            </svg>
                        </button>
                    </div>

                    <!-- Mobile Search -->
                    <div class="mobile-menu__search">
                        <form @submit.prevent="SearchData(); closeMobileMenu();">
                            <input type="text" v-model="search" placeholder="ابحث عن المحتوى...">
                        </form>
                    </div>

                    <!-- Mobile Nav Links -->
                    <ul class="mobile-menu__nav">
                        <li>
                            <router-link to="/" @click="closeMobileMenu">
                                <svg class="nav-icon" viewBox="0 0 20 20">
                                    <path fill="currentColor" d="M18.121,9.88l-7.832-7.836c-0.155-0.158-0.428-0.155-0.584,0L1.842,9.913c-0.262,0.263-0.073,0.705,0.292,0.705h2.069v7.042c0,0.227,0.187,0.414,0.414,0.414h3.725c0.228,0,0.414-0.188,0.414-0.414v-3.313h2.483v3.313c0,0.227,0.187,0.414,0.413,0.414h3.726c0.229,0,0.414-0.188,0.414-0.414v-7.042h2.068h0.004C18.331,10.617,18.389,10.146,18.121,9.88z"/>
                                </svg>
                                الرئيسية
                            </router-link>
                        </li>
                        <li class="has-submenu">
                            <a href="#" @click.prevent="toggleMobileCategories">
                                <svg class="nav-icon" viewBox="0 0 20 20">
                                    <path fill="currentColor" d="M7.228,11.464H1.996c-0.723,0-1.308,0.587-1.308,1.309v5.232c0,0.722,0.585,1.308,1.308,1.308h5.232c0.723,0,1.308-0.586,1.308-1.308v-5.232C8.536,12.051,7.95,11.464,7.228,11.464z"/>
                                </svg>
                                الفـــئــات
                                <svg class="arrow" :class="{ 'rotated': isMobileCategoriesOpen }" viewBox="0 0 20 20">
                                    <path fill="currentColor" d="M5 7l5 5 5-5z"/>
                                </svg>
                            </a>
                            <ul class="submenu" v-show="isMobileCategoriesOpen">
                                <li v-for="category in categoris" :key="category.id">
                                    <router-link :to="{ name: 'Categorys', params: { catid: category.id }}" @click="closeMobileMenu">
                                        {{ category.name_ar }}
                                    </router-link>
                                </li>
                            </ul>
                        </li>
                    </ul>

                    <!-- Mobile Auth Buttons -->
                    <div class="mobile-menu__auth">
                        <template v-if="showHeader">
                            <router-link to="/Unsubscribes" class="btn-mobile-login" @click="closeMobileMenu">
                                الخروج
                            </router-link>
                            <span class="mobile-msisdn">{{ $cookie.getCookie("msisdn") }}</span>
                        </template>
                        <template v-else>
                            <router-link to="/Login" class="btn-mobile-login" @click="closeMobileMenu">
                                الدخول
                            </router-link>
                            <router-link to="/Subscribes" class="btn-mobile-subscribe" @click="closeMobileMenu">
                                الاشتراك
                            </router-link>
                        </template>
                    </div>
                </nav>
            </div>
        </header>
        <!-- end header -->
</template>

<script>
import { ref } from '@vue/reactivity';
import { onMounted, watchEffect } from '@vue/runtime-core';
import { HTTPDSP } from '@/Api/http-dsp';
import { HTTP } from '@/Api/http-common';
import { useRoute, useRouter } from 'vue-router';
import { useCookie } from 'vue-cookie-next'
export default {
    name: 'AppHeader',
    data() {
        return {
            isDropdownOpen: false,
            isMobileMenuOpen: false,
            isMobileCategoriesOpen: false
        };
    },
    methods: {
        toggleDropdown() {
            this.isDropdownOpen = !this.isDropdownOpen;
        },
        closeDropdown() {
            this.isDropdownOpen = false;
        },
        toggleMobileMenu() {
            this.isMobileMenuOpen = !this.isMobileMenuOpen;
            if (this.isMobileMenuOpen) {
                document.body.style.overflow = 'hidden';
            } else {
                document.body.style.overflow = '';
            }
        },
        closeMobileMenu() {
            this.isMobileMenuOpen = false;
            this.isMobileCategoriesOpen = false;
            document.body.style.overflow = '';
        },
        toggleMobileCategories() {
            this.isMobileCategoriesOpen = !this.isMobileCategoriesOpen;
        }
    },
    setup() {
        const router = useRouter();
        const route = useRoute();
        const cookie = useCookie()
        const showHeader = ref(true);
        const search = ref([]);
        const categoris = ref([]);

        watchEffect(() => {
            if (cookie.isCookieAvailable("msisdn")) {
                HTTPDSP.post("DSPCheckLogin.php?msisdn="+cookie.getCookie("msisdn")).then((res) => {
                    if (res.data.status == 1 ) {
                        return;
                    } else {
                        cookie.removeCookie('msisdn');
                    }
                });
                showHeader.value = true;
            } else {
               showHeader.value = false;
            }
        });
        const GetCategories = async () => {
          await HTTP.get('GetAllCategories.php').then(res => {
                categoris.value = res.data.Categories;
            })
        }
        onMounted(() => {
            GetCategories();
        });

        const SearchData = () => {
            router.push({ name: "Searchs", params: { search_id: search.value } });
        }
        return { search, categoris, showHeader, SearchData };
    },
    mounted() {
         let externalScript = document.createElement('script')
             externalScript.setAttribute('src', '/static/js/main.js')
             document.head.appendChild(externalScript)
    }
}
</script>

<style scoped>
/* Zain Header - Main Container */
.zain-header {
    background: linear-gradient(135deg, #0A4D5C 0%, #1A7B8C 100%);
    padding: 15px 0;
    position: relative;
    direction: rtl;
}



.shape {
    width: 80px;
    height: 80px;
}

.shape-1 {
    transform: rotate(15deg) translateX(-20px);
}

.shape-2 {
    transform: rotate(-10deg) translateX(-40px) translateY(-20px);
}

.shape-3 {
    transform: rotate(25deg) translateX(-60px) translateY(10px);
}

/* Header Content */
.zain-header__content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    z-index: 2;
}

/* Logo Section (Right side in RTL) */
.zain-header__logo {
    flex-shrink: 0;
}

.logo-link {
    text-decoration: none;
}

.logo-text {
    color: #00D9B1;
    font-size: 28px;
    font-weight: bold;
    letter-spacing: 1px;
}

/* Navigation Section */
.zain-header__nav {
    display: flex;
    align-items: center;
    gap: 5px;
}

.nav-link {
    display: flex;
    align-items: center;
    gap: 6px;
    color: #fff;
    text-decoration: none;
    padding: 8px 15px;
    border-radius: 20px;
    font-size: 14px;
    font-weight: 500;
    transition: all 0.3s ease;
}

.nav-link:hover {
    background: rgba(255, 255, 255, 0.1);
    color: #00D9B1;
}

.nav-icon {
    width: 16px;
    height: 16px;
}

/* Categories Dropdown */
.nav-dropdown {
    position: relative;
    z-index: 100;
}

.dropdown-toggle {
    background: none;
    border: none;
    cursor: pointer;
    font-family: inherit;
}

.dropdown-arrow {
    width: 16px;
    height: 16px;
    transition: transform 0.3s ease;
}

.dropdown-arrow.rotated {
    transform: rotate(180deg);
}

.categories-dropdown {
    position: absolute;
    top: 100%;
    right: 0;
    min-width: 200px;
    background: #0A4D5C;
    border: 1px solid rgba(0, 217, 177, 0.3);
    border-radius: 12px;
    padding: 10px 0;
    margin-top: 10px;
    list-style: none;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
    z-index: 9999;
}

.categories-dropdown li a {
    display: block;
    padding: 10px 20px;
    color: #fff;
    text-decoration: none;
    font-size: 14px;
    transition: all 0.3s ease;
}

.categories-dropdown li a:hover {
    background: rgba(0, 217, 177, 0.15);
    color: #00D9B1;
    padding-right: 25px;
}

/* Search Section (Center) */
.zain-header__search {
    flex: 1;
    max-width: 400px;
    margin: 0 30px;
}

.search-form {
    width: 100%;
}

.search-input {
    width: 100%;
    background: #1A2E35;
    border: none;
    border-radius: 25px;
    padding: 12px 20px;
    color: #fff;
    font-size: 14px;
    direction: rtl;
    transition: all 0.3s ease;
}

.search-input::placeholder {
    color: rgba(255, 255, 255, 0.5);
}

.search-input:focus {
    outline: none;
    box-shadow: 0 0 0 2px rgba(0, 217, 177, 0.3);
}

/* Actions Section (Left side in RTL) */
.zain-header__actions {
    display: flex;
    align-items: center;
    gap: 20px;
    flex-shrink: 0;
}

/* Auth Buttons */
.auth-buttons {
    display: flex;
    align-items: center;
    gap: 10px;
}

/* Login Button - Teal filled */
.btn-login {
    display: flex;
    align-items: center;
    gap: 8px;
    background: #00D9B1;
    color: #0A4D5C;
    border: none;
    border-radius: 25px;
    padding: 10px 20px;
    font-size: 14px;
    font-weight: 600;
    text-decoration: none;
    transition: all 0.3s ease;
    cursor: pointer;
}

.btn-login:hover {
    background: #00C4A0;
    color: #0A4D5C;
    transform: translateY(-2px);
}

.btn-login .btn-icon {
    width: 16px;
    height: 16px;
    fill: #0A4D5C;
}

/* Subscribe Button - White outlined */
.btn-subscribe {
    display: flex;
    align-items: center;
    gap: 8px;
    background: transparent;
    color: #fff;
    border: 2px solid #fff;
    border-radius: 25px;
    padding: 8px 18px;
    font-size: 14px;
    font-weight: 600;
    text-decoration: none;
    transition: all 0.3s ease;
    cursor: pointer;
}

.btn-subscribe:hover {
    background: rgba(255, 255, 255, 0.1);
    color: #fff;
    transform: translateY(-2px);
}

.btn-subscribe .btn-icon {
    width: 16px;
    height: 16px;
    fill: #fff;
}

/* User MSISDN display */
.user-msisdn {
    color: #fff;
    font-size: 14px;
    padding: 8px 15px;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 20px;
}

/* Zain Logo */
.zain-logo {
    display: flex;
    align-items: center;
}

.zain-logo img {
    width: 80px;
    height: auto;
    filter: brightness(0) invert(1);
}

/* Mobile Menu Button */
.mobile-menu-btn {
    display: none;
    flex-direction: column;
    gap: 5px;
    background: transparent;
    border: none;
    padding: 10px;
    cursor: pointer;
}

.mobile-menu-btn span {
    display: block;
    width: 25px;
    height: 2px;
    background: #fff;
    transition: all 0.3s ease;
}

/* Responsive Design */
@media (max-width: 992px) {
    .zain-header__search {
        max-width: 200px;
        margin: 0 10px;
    }

    .btn-login,
    .btn-subscribe {
        padding: 8px 15px;
        font-size: 13px;
    }
}

@media (max-width: 768px) {
    .zain-header {
        padding: 10px 0;
    }

    .zain-header__content {
        flex-wrap: nowrap;
        justify-content: space-between;
        align-items: center;
    }

    /* Hide on mobile */
    .zain-header__search,
    .zain-header__nav,
    .auth-buttons {
        display: none !important;
    }

    /* Show mobile menu button */
    .mobile-menu-btn {
        display: flex !important;
        order: 1;
    }

    /* Logo styling on mobile */
    .zain-header__logo {
        order: 2;
        flex: 1;
        text-align: center;
    }

    .logo-text {
        font-size: 25px;
    }

    /* Zain logo on mobile */
    .zain-header__actions {
        order: 3;
        gap: 10px;
    }

    .zain-logo img {
        width: 90px;
    }
}

@media (max-width: 480px) {
    .logo-text {
        font-size: 25px;
    }

    .zain-logo img {
        width: 80px;
    }

    .mobile-menu-btn {
        padding: 8px;
    }

    .mobile-menu-btn span {
        width: 20px;
    }
}

/* Animation for shapes */
@keyframes float {
    0%, 100% {
        transform: translateY(-50%) rotate(0deg);
    }
    50% {
        transform: translateY(-55%) rotate(5deg);
    }
}

/* Mobile Menu Button Animation */
.mobile-menu-btn.active span:nth-child(1) {
    transform: rotate(45deg) translate(5px, 5px);
}

.mobile-menu-btn.active span:nth-child(2) {
    opacity: 0;
}

.mobile-menu-btn.active span:nth-child(3) {
    transform: rotate(-45deg) translate(5px, -5px);
}

/* Mobile Menu Overlay */
.mobile-menu-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 998;
}

/* Mobile Menu */
.mobile-menu {
    position: fixed;
    top: 0;
    right: -300px;
    width: 280px;
    height: 100vh;
    background: linear-gradient(180deg, #0A4D5C 0%, #0D3D47 100%);
    z-index: 999;
    transition: right 0.3s ease;
    overflow-y: auto;
    direction: rtl;
}

.mobile-menu.open {
    right: 0;
}

.mobile-menu__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
    border-bottom: 1px solid rgba(0, 217, 177, 0.2);
}

.mobile-menu__title {
    color: #00D9B1;
    font-size: 20px;
    font-weight: bold;
}

.mobile-menu__close {
    background: none;
    border: none;
    color: #fff;
    cursor: pointer;
    padding: 5px;
}

.mobile-menu__close:hover {
    color: #00D9B1;
}

/* Mobile Search */
.mobile-menu__search {
    padding: 15px 20px;
}

.mobile-menu__search input {
    width: 100%;
    padding: 12px 15px;
    background: #1A2E35;
    border: 1px solid rgba(0, 217, 177, 0.3);
    border-radius: 25px;
    color: #fff;
    font-size: 14px;
}

.mobile-menu__search input::placeholder {
    color: rgba(255, 255, 255, 0.5);
}

.mobile-menu__search input:focus {
    outline: none;
    border-color: #00D9B1;
}

/* Mobile Nav */
.mobile-menu__nav {
    list-style: none;
    padding: 0;
    margin: 0;
}

.mobile-menu__nav > li > a,
.mobile-menu__nav > li > router-link {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 15px 20px;
    color: #fff;
    text-decoration: none;
    font-size: 16px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    transition: all 0.3s ease;
}

.mobile-menu__nav > li > a:hover,
.mobile-menu__nav > li > a:active {
    background: rgba(0, 217, 177, 0.1);
    color: #00D9B1;
}

.mobile-menu__nav .nav-icon {
    width: 20px;
    height: 20px;
}

.mobile-menu__nav .arrow {
    width: 20px;
    height: 20px;
    margin-right: auto;
    transition: transform 0.3s ease;
}

.mobile-menu__nav .arrow.rotated {
    transform: rotate(180deg);
}

/* Submenu */
.mobile-menu__nav .submenu {
    list-style: none;
    padding: 0;
    margin: 0;
    background: rgba(0, 0, 0, 0.2);
}

.mobile-menu__nav .submenu li a {
    display: block;
    padding: 12px 20px 12px 40px;
    color: rgba(255, 255, 255, 0.8);
    text-decoration: none;
    font-size: 14px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.05);
}

.mobile-menu__nav .submenu li a:hover {
    color: #00D9B1;
    background: rgba(0, 217, 177, 0.1);
}

/* Mobile Auth */
.mobile-menu__auth {
    padding: 20px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-top: 20px;
    border-top: 1px solid rgba(0, 217, 177, 0.2);
}

.btn-mobile-login {
    display: block;
    text-align: center;
    padding: 12px 20px;
    background: #00D9B1;
    color: #0A4D5C;
    text-decoration: none;
    border-radius: 25px;
    font-weight: 600;
    font-size: 16px;
}

.btn-mobile-login:hover {
    background: #00C4A0;
}

.btn-mobile-subscribe {
    display: block;
    text-align: center;
    padding: 12px 20px;
    background: transparent;
    color: #fff;
    text-decoration: none;
    border: 2px solid #fff;
    border-radius: 25px;
    font-weight: 600;
    font-size: 16px;
}

.btn-mobile-subscribe:hover {
    background: rgba(255, 255, 255, 0.1);
}

.mobile-msisdn {
    text-align: center;
    color: rgba(255, 255, 255, 0.7);
    font-size: 14px;
    padding: 10px;
}
</style>